<svelte:head>
    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==" crossorigin="" />
</svelte:head>

<script>
    import L from 'leaflet';
    import { Button, Icon, Dialog, TextField, List, ListItem } from 'svelte-materialify';
    import { mdiArrowRight, mdiMagnify, mdiCrosshairsGps, mdiClose } from '@mdi/js';
    import { location, height, mode } from '../store';

    export let window;
    export let value;

    let showPlaceSearch = false, query = "";
    let place = null, marker = null;
    let map, mapRef;

    let isHeightSelectorVisible = false;
    let _height = "";

    let _mode;
    mode.subscribe(val => _mode = val);

    $: value, loadMap();

    const ruleNumber = [
        v => {
            return /^[0-9]*$/gm.test(v) || "Altezza non valida"
        }
    ];
    
    function loadMap() {

        if(value !== 4 || map)
            return;
        setTimeout(() => {
            
            map = L.map(mapRef).setView([41.898,12.480], 5);

            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18,
                tileSize: 512,
                zoomOffset: -1,
            }).addTo(map);

            map.on("click", e => {
                place = e.latlng;
                refreshMapPoint();
            });

        }, 0);
    }

    function getGpsPosition() {
        navigator.geolocation.getCurrentPosition(pos => {
            place = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude
            };
            refreshMapPoint();
        });
    }

    function refreshMapPoint(_place=place) {
        if(marker)
            map.removeLayer(marker)
        if(_place){
            marker = new L.marker(_place).addTo(map);
            let latLngs = [ marker.getLatLng() ];
            let markerBounds = L.latLngBounds(latLngs);
            map.flyToBounds(markerBounds);
        }
    }

    async function getPlaces(q) {
        if(!q || q === "")
            return [];
        let result = await getNominatim("search", {
            format: "json",
            q: query
        })
        return result.map(o => {
            return {key: o.display_name, value: {lat: o.lat, lng: o.lon}};
        });
    }

    async function getNominatim(route, params={}, options={}, getResponse=false){
      let p = "";
      Object.entries(params).forEach(([key, val]) => {
        p += `${key}=${val}&`;
      })
      p = p.substring(0, p.length);
      if(getResponse)
        return await fetch(`https://nominatim.sensesquare.eu/nominatim/${route}.php?${p}`, options);
      return await (await fetch(`https://nominatim.sensesquare.eu/nominatim/${route}.php?${p}`, options)).json()
    }

</script>

<main>

    <div class="map" bind:this={mapRef}></div>

    <div class="map-action pa-3">

        <Button fab class="black-text" style="pointer-events: auto" on:click={() => showPlaceSearch = true}>
            <Icon path={mdiMagnify} />
        </Button>

        <Button disabled={!navigator.geolocation} fab class="black-text" style="pointer-events: auto" on:click={getGpsPosition}>
            <Icon path={mdiCrosshairsGps} />
        </Button>

    </div>

    <div class="action-container pa-3">

        <Button style="pointer-events: auto" disabled={place === null} rounded depressed class="green" on:click={() => {
            location.set(place);
            isHeightSelectorVisible = true;
        }}>
            Continua
            <Icon path={mdiArrowRight} class="ml-2" />
        </Button>
        
    </div>

    <div class="dialog-search">
        <Dialog class="black-text" bind:active={showPlaceSearch} fullscreen>
            
            <div class="search-bar pa-3">

                <div class="close-btn">
                    <Button icon depressed on:click={() => showPlaceSearch = false}>
                        <Icon path={mdiClose} />
                    </Button>
                </div>

                <div class="pl-3" style="flex: 1">
                    <TextField color="green" bind:value={query} filled>
                        Cerca
                    </TextField>
                </div>

            </div>

            <List style="width: 100%">

                {#await getPlaces(query)}
                
                    <ListItem selectable class="text-center">
                        ...
                    </ListItem>

                {:then res} 

                    {#if res.length > 0}
                    
                        {#each res as p}
                        
                            <ListItem selectable on:click={() => {
                                place = p.value;
                                refreshMapPoint();
                                showPlaceSearch = false;
                            }}>
                                {p.key}
                            </ListItem>

                        {/each}

                    {:else}

                        <ListItem selectable class="text-center">
                            Nessun risultato
                        </ListItem>

                    {/if}

                {:catch e}

                    <ListItem selectable class="text-center">
                        ...
                    </ListItem>
                    
                {/await}

            </List>
            
        </Dialog>
    </div>

    <div class="dialog-search black-text">

        <Dialog class="pa-5" bind:active={isHeightSelectorVisible}>

            <h6 class="text-h6">
                A che altezza si trova la provetta? *
            </h6>

            <div class="text-body-1 mt-2">
                L'altezza della provetta è richiesta per valutare la concentrazione di inquinamento anche nei piani più alti dei palazzi
                <br><br>
                * L'altezza deve essere presa dal livello della strada
            </div>

            <TextField bind:value={_height} rules={ruleNumber} class="mt-4" color="green" filled inputmode={"numeric"}>
                Altezza (in metri)
            </TextField>

            <Button block disabled={_height === ""} depressed class=" mt-3 green white-text" on:click={() => {
                if(/^[0-9]*$/gm.test(_height)){
                    height.set(_height);
                    if(_mode === "start")
                        window.next();
                    else 
                        value = 6;
                }
            }}>
                Continua
            </Button>

        </Dialog>

    </div>

</main>

<style>

    main {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    main > .map {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }


    main > .action-container {
        position: absolute;
        width: 100%;
        height: auto;
        left: 0;
        bottom: 0;
        display: grid;
        place-items: center;
        z-index: 1002;
        pointer-events: none;
    }

    main > .map-action {
        position: absolute;
        width: auto;
        height: auto;
        top: 0;
        right: 0;
        z-index: 1002;
        pointer-events: none;
        display: grid;
        grid-auto-flow: row;
    }

    main > .dialog-search {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1003;
        pointer-events: none;
        
    }

    .search-bar {
        display: flex;
        flex-direction: row;
    }

    .search-bar > .close-btn {
        display: grid;
        place-items: center;
    }
    
</style>